import React from "react";
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Layout/Home";
import 'antd/dist/reset.css';
const App = () =>{
 


  return (
    <div>
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home/>}></Route>
      
    </Routes> 
    </BrowserRouter>
 
    </div>
  )
  
 }
 export default App;;